import React, { useMemo } from 'react';

import config from 'config';

import { FormattedMessage } from '~/techstyle-shared/react-intl';
import { useDomain } from '~/techstyle-shared/redux-core';

const DynamicFormattedMessage = FormattedMessage;

function useFormattedTldNavLinkMetadata() {
  const domain = useDomain();
  const formattedTldNavLinkMetadata = useMemo(() => {
    let value = null;
    const tldNavLinkMetadata = config.get('public.tldNavLinkMetadata') || [];

    const countries = tldNavLinkMetadata.map((country) => {
      if (country.tld === domain.tld) {
        value = country.code;
      }

      return {
        ...country,
        label: <DynamicFormattedMessage {...country.label} />,
        href: domain.getDomainRedirect({ tld: country.tld }),
      };
    });

    return { value, countries };
  }, [domain]);

  return formattedTldNavLinkMetadata;
}

export default useFormattedTldNavLinkMetadata;
